// PRODUCTION — Formik-bound select
import React from 'react'
import { useFormikContext } from 'formik'
import type { BasicSelectOption } from 'src/components/shared/form/BasicSelect'
import { ProtoSelectStandalone } from '../../ProtoSelectStandalone'

export interface ProtoSelectProps<T> {
  name: keyof T & string
  options: BasicSelectOption[]
  placeholder?: string
  disabled?: boolean
  /** Forces the in-menu search field on or off; defaults to on for long lists. */
  searchable?: boolean
  onOptionSelect?: (option: BasicSelectOption) => void
}

export const ProtoSelect = <T extends object>({
  name,
  options,
  placeholder = 'Select an option',
  disabled = false,
  searchable,
  onOptionSelect,
}: ProtoSelectProps<T>) => {
  const { values, setFieldValue } = useFormikContext<T>()
  const raw = values[name] as unknown
  const valueForStandalone = raw === undefined || raw === null ? '' : (raw as string | number)

  return (
    <ProtoSelectStandalone
      value={valueForStandalone}
      onValueChange={(next) => {
        setFieldValue(name, next as never)
      }}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      searchable={searchable}
      onOptionSelect={onOptionSelect}
    />
  )
}
